"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ContinueShoppingButton = void 0;
class ContinueShoppingButton {
    constructor() {
        this.refererStorageKey = 'product-page-referer';
    }
    init() {
        this.initReferer();
        this.initButtonClick();
    }
    initButtonClick() {
        var _a;
        (_a = document.querySelector('.js-continue-shopping')) === null || _a === void 0 ? void 0 : _a.addEventListener('click', (e) => {
            e.preventDefault();
            const referer = localStorage.getItem(this.refererStorageKey);
            if (!referer) {
                window.location.href = e.target.href;
                return;
            }
            window.location.href = referer;
        });
    }
    initReferer() {
        if (!document.body.classList.contains('single-product')) {
            localStorage.removeItem(this.refererStorageKey);
            return;
        }
        const referer = document.referrer;
        if (!referer) {
            return;
        }
        if (referer === window.location.href) {
            return;
        }
        localStorage.setItem(this.refererStorageKey, referer);
    }
}
exports.ContinueShoppingButton = ContinueShoppingButton;
